import { useLazyQuery } from "@apollo/client/react";
import React, { useEffect, useState, useMemo } from 'react';
import { SelectInput } from '../../../../components/selectInput/SelectInput';
import DataGridGenerico from '../../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../../components/dataGrid/columnHelpers';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import { GET_DELEGACIONES } from '../../../../data/graphQL/queries/Planes/getDelegaciones';
import { adaptDelegacionArray } from '../../../../adapters/delegacionAdapter';

export const StepDelegaciones = ({ stepsData, setStepsData }) => {
  const initialColumns = [
    {
      field: 'id',
      headerName: '#'
    },
    {
      field: 'name',
      headerName: 'Nombre'
    },
    {
      headerName: '',
      field: 'action',
      flex: 0.02,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <div
            onClick={() => handleRemove(row.id)} aria-hidden='true'
            className='item-option clickable-option'>

            <DeleteOutlineIcon className='edit-icon' />
          </div>);

      }
    }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), [stepsData?.delegaciones]);

  const [getDelegaciones, { loading: delegacionesLoading, data: delegacionesData }] = useLazyQuery(GET_DELEGACIONES, {
    fetchPolicy: 'no-cache',
  });
  const [delegaciones, setDelegaciones] = useState([]);

  useEffect(() => {
    if (!delegacionesData) return;
    setDelegaciones([{ id: 0, displayName: "AGREGAR TODAS" }, ...adaptDelegacionArray(delegacionesData)]);
  }, [delegacionesData])

  useEffect(() => {
    if (!delegacionesLoading) {
      getDelegaciones({
        variables: {
          where: {
            or: [
              { descripcion: { ncontains: 'CASA CENTRAL' } }
            ]
          },
          order: [{ descripcion: 'ASC' }]
        }
      });
    }
  }, [])

  const handleRemove = (id) => {
    setStepsData((previousData) => ({ ...previousData, delegaciones: [...(previousData.delegaciones || []).filter((savedDelegacion) => savedDelegacion.idDelegacion != id)] }));
  };

  const handleClickDelegacion = (id) => {
    if (id === 0) {//agregar todas
      const allDelegaciones = delegaciones.filter((d) => d.id !== 0).map((d) => ({ idDelegacion: d.id }));
      setStepsData((previousData) => (
        {
          ...previousData,
          //delegaciones: [delegaciones.filter(d => d.id !== 0).map( d => ({ idDelegacion : d.id}))]
          delegaciones: allDelegaciones
        })
      );
    } else {
      setStepsData((previousData) => (
        {
          ...previousData,
          delegaciones: [...previousData.delegaciones, { idDelegacion: id }]
        })
      );
    }
  };

  return (
    <div className='plan-cuidado-creation'>
      <div className='select-delegaciones-plan'>
        <SelectInput options={delegaciones.filter((d) => !stepsData?.delegaciones?.some((savedDelegacion) => savedDelegacion.idDelegacion === d.id))}
          label='Delegación'
          placeHolder='Elige una delegación'
          onChange={(e) => handleClickDelegacion(e.target.value)} />

      </div>
      <DataGridGenerico
        hideFooterPagination={false}
        columns={columns}
        rows={
          delegaciones?.filter((allDelegaciones) => stepsData?.delegaciones?.some((savedDelegacion) => savedDelegacion.idDelegacion === allDelegaciones.id))
        }
        toolbar={false}
        //pageSize={10}
        totalCount={stepsData?.delegaciones?.lenght}
        rowsPerPage={[10]} />

    </div>);

};